var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"custom-select",attrs:{"reduce":option => option.value,"searchable":false,"options":_vm.options},model:{value:(_vm.fontWeight),callback:function ($$v) {_vm.fontWeight=$$v},expression:"fontWeight"}})
}
var staticRenderFns = []

export { render, staticRenderFns }